import React, { useEffect, useState, lazy, createElement } from 'react';
interface PriceInfo {
  symbol: string;
  code: string;
  newPrice: string;
  oldPrice: string;
  bonusValue: string;
  loading: boolean;
}
export function LandingPage() {
  const [timeLeft, setTimeLeft] = useState(600);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [priceInfo, setPriceInfo] = useState<PriceInfo>({
    symbol: '$',
    code: 'USD',
    newPrice: '19,99',
    oldPrice: '49,99',
    bonusValue: '150',
    loading: true
  });
  // Inject fonts and icons
  useEffect(() => {
    const fontAwesome = document.createElement('link');
    fontAwesome.rel = 'stylesheet';
    fontAwesome.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
    document.head.appendChild(fontAwesome);
    const preconnect1 = document.createElement('link');
    preconnect1.rel = 'preconnect';
    preconnect1.href = 'https://fonts.googleapis.com';
    document.head.appendChild(preconnect1);
    const preconnect2 = document.createElement('link');
    preconnect2.rel = 'preconnect';
    preconnect2.href = 'https://fonts.gstatic.com';
    preconnect2.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect2);
    const googleFonts = document.createElement('link');
    googleFonts.rel = 'stylesheet';
    googleFonts.href = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&family=Oswald:wght@400;500;600;700&display=swap';
    document.head.appendChild(googleFonts);
    return () => {
      document.head.removeChild(fontAwesome);
      document.head.removeChild(preconnect1);
      document.head.removeChild(preconnect2);
      document.head.removeChild(googleFonts);
    };
  }, []);
  // Detect user currency and convert prices
  useEffect(() => {
    const fetchLocalPrice = async () => {
      try {
        // Get user's country/currency from IP
        const geoRes = await fetch('https://ipapi.co/json/');
        const geoData = await geoRes.json();
        const currencyCode: string = geoData.currency || 'USD';
        const countryName: string = geoData.country_name || '';
        if (currencyCode === 'USD') {
          setPriceInfo({
            symbol: '$',
            code: 'USD',
            newPrice: '19,99',
            oldPrice: '49,99',
            bonusValue: '150',
            loading: false
          });
          return;
        }
        // Get exchange rate from USD
        const rateRes = await fetch(`https://api.frankfurter.app/latest?from=USD&to=${currencyCode}`);
        const rateData = await rateRes.json();
        const rate: number = rateData.rates?.[currencyCode];
        if (!rate) {
          setPriceInfo({
            symbol: '$',
            code: 'USD',
            newPrice: '19,99',
            oldPrice: '49,99',
            bonusValue: '150',
            loading: false
          });
          return;
        }
        // Currency symbols map for common currencies
        const symbols: Record<string, string> = {
          ARS: '$',
          MXN: '$',
          COP: '$',
          CLP: '$',
          PEN: 'S/',
          BRL: 'R$',
          EUR: '€',
          GBP: '£',
          CAD: 'CA$',
          AUD: 'A$',
          JPY: '¥',
          CNY: '¥',
          INR: '₹',
          KRW: '₩',
          CHF: 'CHF',
          SEK: 'kr',
          NOK: 'kr',
          DKK: 'kr',
          PLN: 'zł',
          CZK: 'Kč',
          HUF: 'Ft',
          RON: 'lei',
          BGN: 'лв',
          HRK: 'kn',
          RSD: 'din',
          UAH: '₴',
          TRY: '₺',
          ILS: '₪',
          SAR: 'ر.س',
          AED: 'د.إ',
          EGP: 'E£',
          ZAR: 'R',
          NGN: '₦',
          VEF: 'Bs',
          BOB: 'Bs',
          PYG: '₲',
          UYU: '$U',
          GTQ: 'Q',
          HNL: 'L',
          NIO: 'C$',
          CRC: '₡',
          DOP: 'RD$',
          CUP: '$'
        };
        const symbol = symbols[currencyCode] || currencyCode + ' ';
        const formatLocal = (usd: number): string => {
          const converted = usd * rate;
          // For currencies with large values (like ARS, COP, etc.), no decimals
          if (converted >= 100) {
            return Math.round(converted).toLocaleString('es-ES');
          }
          return converted.toFixed(2).replace('.', ',');
        };
        setPriceInfo({
          symbol,
          code: currencyCode,
          newPrice: formatLocal(19.99),
          oldPrice: formatLocal(49.99),
          bonusValue: formatLocal(150),
          loading: false
        });
      } catch {
        // Fallback to USD on any error
        setPriceInfo({
          symbol: '$',
          code: 'USD',
          newPrice: '19,99',
          oldPrice: '49,99',
          bonusValue: '150',
          loading: false
        });
      }
    };
    fetchLocalPrice();
  }, []);
  // Countdown timer
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => prev <= 0 ? 600 : prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const {
    symbol,
    code,
    newPrice,
    oldPrice,
    bonusValue,
    loading
  } = priceInfo;
  const isUSD = code === 'USD';
  // Price display helpers
  const PriceNew = () => <>
      {loading ? <span style={{
      opacity: 0.5
    }} data-id="element-2">
          ...
        </span> : isUSD ? <>
          ${newPrice}{' '}
          <small style={{
        fontSize: '20px'
      }} data-id="element-3">
            USD
          </small>
        </> : <>
          {symbol}
          {newPrice}{' '}
          <small style={{
        fontSize: '20px'
      }} data-id="element-4">
            {code}
          </small>
          <div style={{
        fontSize: '16px',
        color: '#aaa',
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 400,
        marginTop: '4px'
      }} data-id="element-5">
            (~$19,99 USD)
          </div>
        </>}
    </>;
  const PriceOld = () => <span data-id="element-6">
      {loading ? '...' : isUSD ? `$${oldPrice} USD` : `${symbol}${oldPrice} ${code}`}
    </span>;
  const PriceTopBar = () => <>{loading ? '...' : isUSD ? `$${newPrice}` : `${symbol}${newPrice}`}</>;
  return <div id="landing-wrapper" data-id="element-7">
      {/* TOP BAR */}
      <div className="top-bar" data-id="element-8">
        <div className="top-left" data-id="element-9">
          <span className="flash-label" data-id="element-10">🔥 OFERTA:</span>
          <div className="countdown-badge" data-id="element-11">{formatTime(timeLeft)}</div>
        </div>
        <div className="top-right" data-id="element-12">
          <div className="price-stack" data-id="element-13">
            <span className="old-price-xs" data-id="element-14">
              {loading ? '...' : isUSD ? '$49,99' : `${symbol}${oldPrice}`}
            </span>
            <span className="new-price-xs" data-id="element-15">
              <PriceTopBar data-id="element-16" />
            </span>
          </div>
          <a href="#oferta" className="top-btn-mini" data-id="element-17">
            ACCEDER
          </a>
        </div>
      </div>

      {/* HERO SECTION */}
      <section data-id="element-18">
        <div className="custom-container" data-id="element-19">
          <div style={{
          textAlign: 'center',
          marginBottom: '15px'
        }} data-id="element-20">
            <span className="hero-pretitle" data-id="element-21">
              ⚠ MÉTODO DE SEDUCCIÓN PROHIBIDA
            </span>
          </div>
          <h1 className="hero-headline" data-id="element-22">
            DESCUBRE LOS SECRETOS OSCUROS DE LA{' '}
            <span className="highlight" data-id="element-23">PSICOLOGÍA FEMENINA</span>
          </h1>
          <p className="hero-subheadline" data-id="element-24">
            La guía definitiva para dominar el{' '}
            <strong data-id="element-25">"Instinto Primitivo"</strong> y hacer que cualquier mujer
            sienta una atracción incontrolable por ti, sin importar tu físico o
            tu dinero.
          </p>
          <div className="hero-promise" data-id="element-26">
            <p data-id="element-27">
              <em data-id="element-28">
                "No importa si te han rechazado mil veces. Este método activa
                los interruptores biológicos que obligan al cerebro femenino a
                perseguirte. Dejarás de ser el 'amigo' para convertirte en su
                obsesión o <strong data-id="element-29">te devuelvo tu dinero.</strong>"
              </em>
            </p>
          </div>
          <div className="hero-media" data-id="element-30">
            <img src="https://i.postimg.cc/x1trS9Yj/20260129-1115-Misterioso-Futuro-Digital-simple-compose-01kg51n1frfqxrf92v4pd6weyq.png" alt="Bundle Completo" data-id="element-31" />
          </div>
          <a href="#oferta" className="cta-button" data-id="element-32">
            ¡SÍ! QUIERO ACCESO INMEDIATO —{' '}
            {loading ? '...' : `${symbol}${newPrice} ${code}`}
          </a>
        </div>
      </section>

      {/* PAIN POINTS */}
      <section style={{
      background: '#000'
    }} data-id="element-33">
        <div className="custom-container" data-id="element-34">
          <h2 style={{
          textAlign: 'center',
          marginBottom: '30px'
        }} data-id="element-35">
            ESTO ES <span className="highlight" data-id="element-36">PARA TI QUE...</span>
          </h2>
          <div className="pain-card" data-id="element-37">
            <div className="pain-title" data-id="element-38">
              <i className="fas fa-check-circle" data-id="element-39"></i> TE SIENTES INVISIBLE PARA
              ELLAS
            </div>
            <div className="pain-text" data-id="element-40">
              Haces de todo, eres amable, atento, pero ellas te ignoran por
              completo mientras persiguen a hombres que las tratan peor que tú.
            </div>
          </div>
          <div className="pain-card" data-id="element-41">
            <div className="pain-title" data-id="element-42">
              <i className="fas fa-check-circle" data-id="element-43"></i> SIEMPRE TERMINAS EN LA
              FRIENDZONE
            </div>
            <div className="pain-text" data-id="element-44">
              Te conviertes en su "paño de lágrimas", escuchas sus problemas
              amorosos, pero nunca logras ser el hombre con el que ella quiere
              acostarse.
            </div>
          </div>
          <div className="pain-card" data-id="element-45">
            <div className="pain-title" data-id="element-46">
              <i className="fas fa-check-circle" data-id="element-47"></i> SIENTES ANSIEDAD AL
              ACERCARTE
            </div>
            <div className="pain-text" data-id="element-48">
              El miedo al rechazo te paraliza. Ves a una mujer hermosa y tu
              mente se queda en blanco, perdiendo oportunidad tras oportunidad.
            </div>
          </div>
        </div>
      </section>

      {/* MODULES */}
      <section data-id="element-49">
        <div className="custom-container" data-id="element-50">
          <h2 style={{
          textAlign: 'center'
        }} data-id="element-51">
            LO QUE VAS A <span className="highlight" data-id="element-52">DOMINAR</span>
          </h2>
          <div className="modules-grid" data-id="element-53">
            <div className="module-item" data-id="element-54">
              <div className="module-icon" data-id="element-55">
                <i className="fas fa-bomb" data-id="element-56"></i>
              </div>
              <div className="module-content" data-id="element-57">
                <h3 data-id="element-58">01. EL DESPERTAR DEL INSTINTO</h3>
                <p data-id="element-59">
                  Aprende a hackear su mente reptiliana para que sienta deseo
                  sexual inmediato, sin lógica de por medio.
                </p>
              </div>
            </div>
            <div className="module-item" data-id="element-60">
              <div className="module-icon" data-id="element-61">
                <i className="fas fa-brain" data-id="element-62"></i>
              </div>
              <div className="module-content" data-id="element-63">
                <h3 data-id="element-64">02. LENGUAJE CORPORAL ALFA</h3>
                <p data-id="element-65">
                  Proyecta una presencia dominante que intimida a otros hombres
                  y excita a las mujeres sin decir una palabra.
                </p>
              </div>
            </div>
            <div className="module-item" data-id="element-66">
              <div className="module-icon" data-id="element-67">
                <i className="fas fa-user-secret" data-id="element-68"></i>
              </div>
              <div className="module-content" data-id="element-69">
                <h3 data-id="element-70">03. GESTIÓN DEL RECHAZO</h3>
                <p data-id="element-71">
                  Vuélvete inmune al "no". Transforma sus pruebas y objeciones
                  en combustible para aumentar su interés.
                </p>
              </div>
            </div>
            <div className="module-item" data-id="element-72">
              <div className="module-icon" data-id="element-73">
                <i className="fas fa-mobile-alt" data-id="element-74"></i>
              </div>
              <div className="module-content" data-id="element-75">
                <h3 data-id="element-76">04. EL JUEGO DEL TEXTO</h3>
                <p data-id="element-77">
                  Mensajes diseñados científicamente para generar intriga, celos
                  y necesidad de verte urgentemente.
                </p>
              </div>
            </div>
            <div className="module-item" data-id="element-78">
              <div className="module-icon" data-id="element-79">
                <i className="fas fa-stopwatch" data-id="element-80"></i>
              </div>
              <div className="module-content" data-id="element-81">
                <h3 data-id="element-82">05. SEXUALIDAD DOMINANTE</h3>
                <p data-id="element-83">
                  Deja de pedir permiso. Aprende a escalar físicamente y
                  satisface sus fantasías más oscuras.
                </p>
              </div>
            </div>
            <div className="module-item" data-id="element-84">
              <div className="module-icon" data-id="element-85">
                <i className="fas fa-comments" data-id="element-86"></i>
              </div>
              <div className="module-content" data-id="element-87">
                <h3 data-id="element-88">06. PSICOLOGÍA OSCURA</h3>
                <p data-id="element-89">
                  Técnicas avanzadas de manipulación emocional ética para que
                  ella se vuelva adicta a tu validación.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MID CTA */}
      <section style={{
      padding: '30px 20px',
      borderBottom: '1px solid #111'
    }} data-id="element-90">
        <div className="custom-container" data-id="element-91">
          <div style={{
          textAlign: 'center',
          maxWidth: '600px',
          margin: '0 auto'
        }} data-id="element-92">
            <p style={{
            color: '#ccc',
            marginBottom: '15px',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }} data-id="element-93">
              ⚠ No dejes pasar otra oportunidad
            </p>
            <a href="#oferta" className="cta-button" data-id="element-94">
              ¡QUIERO ACCEDER AL SISTEMA YA! —{' '}
              {loading ? '...' : `${symbol}${newPrice} ${code}`}
            </a>
            <p style={{
            fontSize: '12px',
            color: '#555',
            marginTop: '10px'
          }} data-id="element-95">
              <i className="fas fa-bolt" style={{
              color: '#FFD700'
            }} data-id="element-96"></i>{' '}
              Descarga inmediata y segura
            </p>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section style={{
      background: '#050505'
    }} data-id="element-97">
        <div className="custom-container" data-id="element-98">
          <h2 style={{
          textAlign: 'center',
          lineHeight: 1.2
        }} data-id="element-99">
            FILTRACIONES DEL <span className="highlight" data-id="element-100">CÍRCULO PRIVADO</span>
          </h2>
          <p style={{
          textAlign: 'center',
          fontSize: '14px',
          color: '#777'
        }} data-id="element-101">
            Resultados reales de miembros (identidades protegidas).
          </p>
          <div className="testi-grid" data-id="element-102">
            <div className="chat-card" data-id="element-103">
              <div className="chat-header" data-id="element-104">
                <div className="chat-avatar" data-id="element-105">
                  <img src="https://randomuser.me/api/portraits/men/44.jpg" alt="User" loading="lazy" data-id="element-106" />
                </div>
                <div className="chat-info" data-id="element-107">
                  <div className="chat-number" data-id="element-108">+52 1 55 8392 **</div>
                  <div className="chat-status" data-id="element-109">ayer</div>
                </div>
              </div>
              <div className="chat-body" data-id="element-110">
                <div className="chat-bubble" data-id="element-111">
                  Bro, apliqué el módulo de "Instinto Primitivo" con mi ex... no
                  vas a creer lo que pasó.<div className="chat-meta" data-id="element-112">22:14</div>
                </div>
                <div className="chat-bubble" data-id="element-113">
                  Me escribió a las 3 AM diciendo que no podía dejar de pensar
                  en mí. Es una locura cómo cambia su actitud cuando proyectas
                  dominio. 🔥<div className="chat-meta" data-id="element-114">22:15</div>
                </div>
              </div>
            </div>
            <div className="chat-card" data-id="element-115">
              <div className="chat-header" data-id="element-116">
                <div className="chat-avatar" data-id="element-117">
                  <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="User" loading="lazy" data-id="element-118" />
                </div>
                <div className="chat-info" data-id="element-119">
                  <div className="chat-number" data-id="element-120">+54 9 11 3644 **</div>
                  <div className="chat-status" data-id="element-121">hoy</div>
                </div>
              </div>
              <div className="chat-body" data-id="element-122">
                <div className="chat-bubble" data-id="element-123">
                  <div className="audio-msg" data-id="element-124">
                    <i className="fas fa-play play-icon" data-id="element-125"></i>
                    <div className="audio-track" data-id="element-126">
                      <div className="audio-wave" data-id="element-127"></div>
                      <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                      fontSize: '10px',
                      color: '#bbb'
                    }} data-id="element-128">
                        <span data-id="element-129">0:14</span>
                        <span data-id="element-130">
                          <i className="fas fa-microphone mic-icon" data-id="element-131"></i>
                        </span>
                      </div>
                    </div>
                    <img src="https://randomuser.me/api/portraits/men/32.jpg" style={{
                    width: '25px',
                    height: '25px',
                    borderRadius: '50%',
                    opacity: 0.5
                  }} loading="lazy" alt="" data-id="element-132" />
                  </div>
                  <div className="chat-meta" data-id="element-133">09:30</div>
                </div>
                <div className="chat-bubble" data-id="element-134">
                  La técnica de la mirada funcionó. Se puso nerviosa y empezó a
                  buscar mi aprobación. Gracias por enseñarme a dejar de ser el
                  "buen tipo".<div className="chat-meta" data-id="element-135">09:31</div>
                </div>
              </div>
            </div>
            <div className="chat-card" data-id="element-136">
              <div className="chat-header" data-id="element-137">
                <div className="chat-avatar" data-id="element-138">
                  <img src="https://randomuser.me/api/portraits/men/11.jpg" alt="User" loading="lazy" data-id="element-139" />
                </div>
                <div className="chat-info" data-id="element-140">
                  <div className="chat-number" data-id="element-141">+34 622 81 * *</div>
                  <div className="chat-status" data-id="element-142">hoy</div>
                </div>
              </div>
              <div className="chat-body" data-id="element-143">
                <div className="chat-bubble" data-id="element-144">
                  El bono de Kamasutra... sin palabras. Mi pareja está fascinada
                  con el cambio. 😂<div className="chat-meta" data-id="element-145">14:05</div>
                </div>
                <div className="chat-bubble" data-id="element-146">
                  Nunca pensé que entender la psicología femenina me daría tanto
                  poder. Vale cada centavo.
                  <div className="chat-meta" data-id="element-147">14:06</div>
                </div>
              </div>
            </div>
            <div className="chat-card" data-id="element-148">
              <div className="chat-header" data-id="element-149">
                <div className="chat-avatar" data-id="element-150">
                  <img src="https://randomuser.me/api/portraits/men/67.jpg" alt="User" loading="lazy" data-id="element-151" />
                </div>
                <div className="chat-info" data-id="element-152">
                  <div className="chat-number" data-id="element-153">+57 301 559 **</div>
                  <div className="chat-status" data-id="element-154">ayer</div>
                </div>
              </div>
              <div className="chat-body" data-id="element-155">
                <div className="chat-bubble" data-id="element-156">
                  Parce, llevo 3 días con el método y ya tengo 2 citas para el
                  fin de semana. Yo era el que siempre se quedaba solo en el
                  bar.<div className="chat-meta" data-id="element-157">18:40</div>
                </div>
                <div className="chat-bubble" data-id="element-158">
                  La confianza que te da saber EXACTAMENTE qué hacer es real.
                  <div className="chat-meta" data-id="element-159">18:41</div>
                </div>
              </div>
            </div>
            <div className="chat-card" data-id="element-160">
              <div className="chat-header" data-id="element-161">
                <div className="chat-avatar" data-id="element-162">
                  <img src="https://randomuser.me/api/portraits/men/55.jpg" alt="User" loading="lazy" data-id="element-163" />
                </div>
                <div className="chat-info" data-id="element-164">
                  <div className="chat-number" data-id="element-165">+56 9 7882 **</div>
                  <div className="chat-status" data-id="element-166">hoy</div>
                </div>
              </div>
              <div className="chat-body" data-id="element-167">
                <div className="chat-bubble" data-id="element-168">
                  Usé la técnica de "Preselección" en Instagram y me escribieron
                  3 mujeres que antes me ignoraban.
                  <div className="chat-meta" data-id="element-169">11:20</div>
                </div>
                <div className="chat-bubble" data-id="element-170">
                  Es increíble cómo funciona la mente de ellas cuando sabes qué
                  botones apretar.<div className="chat-meta" data-id="element-171">11:21</div>
                </div>
              </div>
            </div>
            <div className="chat-card" data-id="element-172">
              <div className="chat-header" data-id="element-173">
                <div className="chat-avatar" data-id="element-174">
                  <img src="https://randomuser.me/api/portraits/men/78.jpg" alt="User" loading="lazy" data-id="element-175" />
                </div>
                <div className="chat-info" data-id="element-176">
                  <div className="chat-number" data-id="element-177">+598 99 231 *</div>
                  <div className="chat-status" data-id="element-178">hoy</div>
                </div>
              </div>
              <div className="chat-body" data-id="element-179">
                <div className="chat-bubble" data-id="element-180">
                  Pensé que a mis 40 años ya no tenía oportunidad. Me equivoqué.
                  Ayer salí con una de 25 y yo tenía el control total de la
                  situación.<div className="chat-meta" data-id="element-181">20:45</div>
                </div>
                <div className="chat-bubble" data-id="element-182">
                  Me siento renacido, saludos desde Montevideo.
                  <div className="chat-meta" data-id="element-183">20:46</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STANDARD BONUSES */}
      <section data-id="element-184">
        <div className="custom-container" data-id="element-185">
          <h2 style={{
          textAlign: 'center'
        }} data-id="element-186">
            TUS BONUS <span className="highlight" data-id="element-187">INCLUIDOS</span>
          </h2>
          <p style={{
          textAlign: 'center',
          fontSize: '14px',
          color: '#999'
        }} data-id="element-188">
            Herramientas tácticas GRATIS con tu compra:
          </p>
          <div className="bonus-grid" data-id="element-189">
            <div className="bonus-card" data-id="element-190">
              <div className="bonus-img-container" data-id="element-191">
                <img src="https://i.postimg.cc/WzTtt0Yj/20260129-1128-Image-Generation-simple-compose-01kg52f522ep2sxprbte5d5h3a.png" alt="Código Supremo" loading="lazy" data-id="element-192" />
              </div>
              <div className="bonus-content" data-id="element-193">
                <span className="bonus-tag" data-id="element-194">GUÍA DE CAMPO</span>
                <h3 className="bonus-title" data-id="element-195">CÓDIGO SUPREMO</h3>
                <p className="bonus-desc" data-id="element-196">
                  Conquista en gimnasios, discotecas y malls. Guía para iniciar
                  conversaciones naturales sin errores.
                </p>
              </div>
            </div>
            <div className="bonus-card" data-id="element-197">
              <div className="bonus-img-container" data-id="element-198">
                <img src="https://i.postimg.cc/RFNxdh3m/20260129-1144-Image-Generation-simple-compose-01kg53bdbgfj8sf0sagz8addzn.png" alt="Mensajes Hipnóticos" loading="lazy" data-id="element-199" />
              </div>
              <div className="bonus-content" data-id="element-200">
                <span className="bonus-tag" data-id="element-201">COPY & PASTE</span>
                <h3 className="bonus-title" data-id="element-202">300 MENSAJES</h3>
                <p className="bonus-desc" data-id="element-203">
                  No pienses qué decir. 300 plantillas estratégicas para cada
                  etapa. Copia, pega y genera interés.
                </p>
              </div>
            </div>
            <div className="bonus-card" data-id="element-204">
              <div className="bonus-img-container" data-id="element-205">
                <img src="https://i.postimg.cc/jdj3JmJg/20260129-1155-Image-Generation-simple-compose-01kg53z7yffrxacqb0gq7kr9q4.png" alt="Desafío 7 Días" loading="lazy" data-id="element-206" />
              </div>
              <div className="bonus-content" data-id="element-207">
                <span className="bonus-tag" data-id="element-208">PLAN DE ACCIÓN</span>
                <h3 className="bonus-title" data-id="element-209">DESAFÍO 7 DÍAS</h3>
                <p className="bonus-desc" data-id="element-210">
                  Retos diarios para salir de la zona de confort. Gana confianza
                  auténtica y experiencia real.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SPECIAL OFFER */}
      <section className="special-offer-section" data-id="element-211">
        <div className="custom-container" data-id="element-212">
          <div style={{
          textAlign: 'center'
        }} data-id="element-213">
            <span className="special-badge" data-id="element-214">⚠️ OFERTA FLASH LIMITADA</span>
            <h2 style={{
            fontSize: '28px',
            marginBottom: '10px'
          }} data-id="element-215">
              SOLO POR HOY RECIBE ESTOS{' '}
              <span className="highlight" data-id="element-216">3 BONUS EXTRA</span>
            </h2>
            <p style={{
            fontSize: '15px',
            marginBottom: '30px',
            color: '#ccc'
          }} data-id="element-217">
              Valorados en{' '}
              <strong style={{
              color: '#FFD700'
            }} data-id="element-218">
                {loading ? '...' : isUSD ? '$150 USD' : `${symbol}${bonusValue} ${code} (~$150 USD)`}
              </strong>
              , hoy son tuyos GRATIS.
            </p>
          </div>
          <div className="bonus-grid" data-id="element-219">
            <div className="bonus-card" style={{
            borderColor: '#333'
          }} data-id="element-220">
              <div className="bonus-img-container" data-id="element-221">
                <img src="https://i.postimg.cc/XJHdMH7G/20260129-1158-Image-Generation-simple-compose-01kg5448amfzytxpr2548ekd2v.png" alt="Kamasutra" loading="lazy" data-id="element-222" />
              </div>
              <div className="bonus-content" data-id="element-223">
                <h3 className="bonus-title" style={{
                color: 'var(--brand-red)'
              }} data-id="element-224">
                  KAMASUTRA SUPREMO
                </h3>
                <p className="bonus-desc" data-id="element-225">
                  30 posiciones explícitas para maximizar el placer. Adaptadas
                  para cualquier tamaño.
                </p>
              </div>
            </div>
            <div className="bonus-card" style={{
            borderColor: '#333'
          }} data-id="element-226">
              <div className="bonus-img-container" data-id="element-227">
                <img src="https://i.postimg.cc/C1BkgCBw/20260129-1159-Disen-o-Elegante-del-Libro-simple-compose-01kg547gc2e2nrjmsww85xx3cb.png" alt="Game Master" loading="lazy" data-id="element-228" />
              </div>
              <div className="bonus-content" data-id="element-229">
                <h3 className="bonus-title" style={{
                color: 'var(--brand-red)'
              }} data-id="element-230">
                  GAME MASTER
                </h3>
                <p className="bonus-desc" data-id="element-231">
                  Resumen táctico de Neil Strauss. Misterio, lenguaje corporal y
                  aperturas sin relleno.
                </p>
              </div>
            </div>
            <div className="bonus-card" style={{
            borderColor: '#333'
          }} data-id="element-232">
              <div className="bonus-img-container" data-id="element-233">
                <img src="https://i.postimg.cc/CLmGbKVj/20260129-1209-Image-Generation-simple-compose-01kg54sr5qe5jvpdpxmm6ds6t6.png" alt="Arte Seducción" loading="lazy" data-id="element-234" />
              </div>
              <div className="bonus-content" data-id="element-235">
                <h3 className="bonus-title" style={{
                color: 'var(--brand-red)'
              }} data-id="element-236">
                  ARTE DE LA SEDUCCIÓN
                </h3>
                <p className="bonus-desc" data-id="element-237">
                  Psicología de Robert Greene. Domina los 9 tipos de seductores
                  para ser magnético.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="oferta" data-id="element-238">
        <div className="custom-container" data-id="element-239">
          <div className="summary-section" data-id="element-240">
            <h3 className="summary-headline" data-id="element-241">
              No olvides que tu compra incluye todo lo siguiente:
            </h3>
            <div className="summary-list" data-id="element-242">
              <div className="summary-item" data-id="element-243">
                <span className="item-title" data-id="element-244">
                  <i className="fas fa-check-square item-check" data-id="element-245"></i> Manual
                  Principal en PDF: «El Juego Supremo»
                </span>
              </div>
              <div className="summary-item" data-id="element-246">
                <span className="item-title red" data-id="element-247">
                  BONO 1: Código Supremo: Conquista en Cualquier Escenario
                </span>
              </div>
              <div className="summary-item" data-id="element-248">
                <span className="item-title red" data-id="element-249">
                  BONO 2: 300 Plantillas de mensajes listos y clasificados
                </span>
              </div>
              <div className="summary-item" data-id="element-250">
                <span className="item-title red" data-id="element-251">
                  BONO 3: Desafío Supremo de 7 Días
                </span>
              </div>
              <div className="summary-item" data-id="element-252">
                <span className="item-title red" data-id="element-253">
                  BONO 4: Círculo Supremo en Telegram
                </span>
              </div>
              <div className="summary-item" data-id="element-254">
                <span className="item-title gold" data-id="element-255">
                  <i className="fas fa-star item-star" data-id="element-256"></i> Ebook Especial #1:
                  KamaSutra Supremo
                </span>
              </div>
              <div className="summary-item" data-id="element-257">
                <span className="item-title gold" data-id="element-258">
                  <i className="fas fa-star item-star" data-id="element-259"></i> Super Ebook #2: «The
                  Game Master» (Neil Strauss)
                </span>
              </div>
              <div className="summary-item" data-id="element-260">
                <span className="item-title gold" data-id="element-261">
                  <i className="fas fa-star item-star" data-id="element-262"></i> Super Ebook #3: «El
                  Arte Supremo» (Robert Greene)
                </span>
              </div>
            </div>
          </div>

          <div className="pricing-box" data-id="element-263">
            <h3 style={{
            fontSize: '28px'
          }} data-id="element-264">
              ACCESO TOTAL AL SISTEMA
            </h3>
            <p style={{
            color: '#999',
            marginBottom: '20px'
          }} data-id="element-265">
              Pack Completo + 6 Bonus Exclusivos
            </p>

            <div style={{
            textDecoration: 'line-through',
            color: '#555',
            fontSize: '24px'
          }} data-id="element-266">
              <PriceOld data-id="element-267" />
            </div>

            <div className="new-price" data-id="element-268">
              <PriceNew data-id="element-269" />
            </div>

            <a href="https://buy.stripe.com/5kQdR9cdvf8640OaQLefC08" className="cta-button" data-id="element-270">
              ¡QUIERO ACCEDER AL SISTEMA YA! —{' '}
              {loading ? '...' : `${symbol}${newPrice} ${code}`}
            </a>

            <div style={{
            fontSize: '12px',
            color: '#666',
            marginTop: '20px'
          }} data-id="element-271">
              <i className="fas fa-lock" data-id="element-272"></i> Pago Seguro SSL 256-bit
              {!isUSD && !loading && <div style={{
              marginTop: '6px',
              color: '#555'
            }} data-id="element-273">
                  * El cobro se realiza en USD ($19,99). La conversión es
                  referencial.
                </div>}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section style={{
      background: '#000'
    }} data-id="element-274">
        <div className="custom-container" data-id="element-275">
          <h2 style={{
          textAlign: 'center',
          marginBottom: '30px'
        }} data-id="element-276">
            PREGUNTAS <span className="highlight" data-id="element-277">FRECUENTES</span>
          </h2>
          <div className="faq-item" data-id="element-278">
            <div className={`faq-header ${openFaq === 0 ? 'active' : ''}`} onClick={() => toggleFaq(0)} data-id="element-279">
              1. ¿Necesito un teléfono celular costoso para aprovechar el curso?
              <i className="fas fa-chevron-down" data-id="element-280"></i>
            </div>
            <div className="faq-body" style={{
            maxHeight: openFaq === 0 ? '200px' : '0'
          }} data-id="element-281">
              <div className="faq-content" data-id="element-282">
                No. El curso está diseñado para cualquier teléfono,
                independientemente del modelo o marca. Todo el material es
                accesible desde dispositivos básicos.
              </div>
            </div>
          </div>
          <div className="faq-item" data-id="element-283">
            <div className={`faq-header ${openFaq === 1 ? 'active' : ''}`} onClick={() => toggleFaq(1)} data-id="element-284">
              2. ¿Cuándo recibo mi Programa?
              <i className="fas fa-chevron-down" data-id="element-285"></i>
            </div>
            <div className="faq-body" style={{
            maxHeight: openFaq === 1 ? '200px' : '0'
          }} data-id="element-286">
              <div className="faq-content" data-id="element-287">
                Inmediatamente después de tu compra, recibirás un correo
                electrónico con el acceso a tu programa para que puedas comenzar
                a utilizar ¡Hoy Mismo!
              </div>
            </div>
          </div>
          <div className="faq-item" data-id="element-288">
            <div className={`faq-header ${openFaq === 2 ? 'active' : ''}`} onClick={() => toggleFaq(2)} data-id="element-289">
              3. ¿El curso es 100% online?
              <i className="fas fa-chevron-down" data-id="element-290"></i>
            </div>
            <div className="faq-body" style={{
            maxHeight: openFaq === 2 ? '200px' : '0'
          }} data-id="element-291">
              <div className="faq-content" data-id="element-292">
                Sí. Todo el contenido está disponible en línea para que puedas
                aprenderlo a tu propio ritmo y en tu propio tiempo, sin horarios
                fijos.
              </div>
            </div>
          </div>
          <div className="faq-item" data-id="element-293">
            <div className={`faq-header ${openFaq === 3 ? 'active' : ''}`} onClick={() => toggleFaq(3)} data-id="element-294">
              4. ¿En qué formato recibiré el Programa?
              <i className="fas fa-chevron-down" data-id="element-295"></i>
            </div>
            <div className="faq-body" style={{
            maxHeight: openFaq === 3 ? '200px' : '0'
          }} data-id="element-296">
              <div className="faq-content" data-id="element-297">
                Todo el programa lo tendrás en formato PDF de alta calidad,
                alojados de forma segura en la nube para descargarlos o incluso
                imprimirlos si lo deseas.
              </div>
            </div>
          </div>
          <div className="faq-item" data-id="element-298">
            <div className={`faq-header ${openFaq === 4 ? 'active' : ''}`} onClick={() => toggleFaq(4)} data-id="element-299">
              5. ¿Por cuánto tiempo tendré acceso al Programa?
              <i className="fas fa-chevron-down" data-id="element-300"></i>
            </div>
            <div className="faq-body" style={{
            maxHeight: openFaq === 4 ? '200px' : '0'
          }} data-id="element-301">
              <div className="faq-content" data-id="element-302">
                Por un único pago de{' '}
                <strong data-id="element-303">
                  {loading ? '...' : isUSD ? '$19,99 USD' : `${symbol}${newPrice} ${code} (~$19,99 USD)`}
                </strong>{' '}
                tendrás acceso de por vida al programa y a todas las
                actualizaciones futuras, sin suscripciones mensuales.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{
      textAlign: 'center',
      padding: '30px',
      fontSize: '12px',
      color: '#444',
      borderTop: '1px solid #222'
    }} data-id="element-304">
        <p data-id="element-305">© 2026 EL JUEGO SUPREMO. TODOS LOS DERECHOS RESERVADOS.</p>
        <p data-id="element-306">Disclaimer: Este sitio no es parte de Facebook o Facebook Inc.</p>
      </footer>
    </div>;
}